// extracted by mini-css-extract-plugin
export default {"tarifsPage_section":"Its_tarifsPage_section__eBg7p","mobile_tarifs":"Its_mobile_tarifs__H4ptd","desktop_tarifs":"Its_desktop_tarifs__ZFW-G"};